import { useProjectAnalysisQuery } from '../generated/graphql'

export const useProjectAnalysis = (noteId: string) => {
  const { data, loading } = useProjectAnalysisQuery({ variables: { noteId } })
  return {
    loading,
    data,
  }
}
